var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('b-col',{attrs:{"cols":"11"}},[_c('b-alert',{attrs:{"show":"","variant":_vm.message.variant || 'info'},domProps:{"innerHTML":_vm._s(_vm.message.text)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }